// import AppModal from 'components/modal/Modal'
import AppModal from 'components/modal/Modal'
import { Icon } from 'components/UI'
import React from 'react'
import { useNavigate } from 'react-router'

const VerificationStatus = ({
  open,
  data,
  setOpen,
  isSuccess = false,
  loading = false,
  status,
}) => {
  const failureReasons = [
    'Name on ID does not match entered details',
    'Failed liveness test',
    'Face does not match uploaded ID photo',
    'Blurry or unreadable ID document',
    'Unsupported ID type',
  ]
  const navigate = useNavigate()
  return (
    <>
      <AppModal
        open={open}
        // handleClose={() => {
        //   setOpen((prev) => !prev)
        // }}
      >
        <div className="flex flex-col items-center w-full justify-center min-h-[200px] rounded-2xl shadow-lg p-6 py-10  text-primary-75  bg-primary-50 ">
          {isSuccess ? (
            <>
              {/* <CheckCircle className="w-16 h-16 text-green-500" /> */}
              <h2 className="mt-4 text-xl font-semibold  text-primary-75 ">
                Verification Successful
              </h2>
              <p className="text-gray-500 mt-2">Your account has been successfully verified.</p>
            </>
          ) : (
            <>
              {/* <XCircle className="w-16 h-16 text-red-500" /> */}
              <h2 className="text-xl font-semibold text-red-500">KYC Verification Failed</h2>
              <p className="text-gray-500 mt-2">
                We could not verify your account. Please try again.
              </p>
              <div className="flex items-center flex-col gap-3 text-red-600 mb-4">
                <Icon name="warning-triangle" color="#f79009" width={180} height={180} />
              </div>

              {/* <p className="text-gray-600 mb-4">
                Unfortunately, we could not complete your KYC verification. Below are some possible
                reasons for the failure:
              </p> */}

              <ul className="list-disc list-inside space-y-2 text-gray-700 mb-6">
                {failureReasons.map((reason, index) => (
                  <li key={index}>{reason}</li>
                ))}
              </ul>

              {/* <button
                onClick={() => alert('Retrying verification...')}
                className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-semibold px-4 py-2 rounded-xl shadow-md transition"
              >
                <RefreshCw size={18} />
                Retry Verification
              </button> */}
            </>
          )}
          <div className="flex w-full my-10 gap-4">
            <button
              // onClick={() => {
              //   setOpen(false)
              //   // handleResetDoc()
              // }}
              // onClick={() => navigate('/tutor/register/kyc')}
              onClick={() => setOpen(false)}
              className="flex-1 border-primary-75 rounded-lg  py-2 text-primary-100 font-semibold border-2"
            >
              Back
            </button>
            {isSuccess ? (
              <button
                // disabled={loading}
                onClick={() => navigate('tutor/register/kyc')}
                className="flex-1  bg-primary-75 rounded-lg  py-2 text-white font-semibold border"
              >
                {loading ? 'loading...' : 'Continue'}
              </button>
            ) : (
              <button
                // disabled={loading}
                onClick={() => navigate('tutor/register/kyc')}
                className="flex-1  bg-primary-75 rounded-lg  py-2 text-white font-semibold border"
              >
                {loading ? 'loading...' : 'Logout'}
              </button>
            )}
          </div>
        </div>
      </AppModal>
    </>
  )
}

export default VerificationStatus
